import { SafeString } from 'handlebars';
import { HawkSearchComponents, HawkSearchGlobal, QuerySuggestionsComponentConfig, QuerySuggestionsComponentModel, QuerySuggestionsData } from '@models';
import { searchService } from '@services';
import { BaseComponent } from '../../base.component';
import defaultHtml from './query-suggestions.component.hbs';

declare let HawkSearch: HawkSearchGlobal;

export class QuerySuggestionsComponent extends BaseComponent<QuerySuggestionsComponentConfig, QuerySuggestionsData, QuerySuggestionsComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'query-suggestions';
    protected override defaultHtml = defaultHtml;
    protected override bindFromEvent = true;

    protected override registerHelpers(): void {
        super.registerHelpers();

        const orDelimeterString = this.configuration?.strings?.orDelimeter ?? 'or';
        const promptString = this.configuration?.strings?.prompt ?? 'Did you mean to search for ${suggestions}?';

        this.handlebars.registerHelper('query-suggestions', function (querySuggestions: Array<string>): SafeString {
            function linkFunction(query: string): string {
                return `<a hawksearch-query="${encodeURIComponent(query)}" class="query-suggestions__link">${query}</a>`;
            }

            const generalDelimeter = ', ';
            const lastDelimeter = `, ${orDelimeterString} `;

            let suggestions = '';

            if (querySuggestions.length <= 2) {
                suggestions = querySuggestions.map(linkFunction).join(` ${orDelimeterString} `);
            } else {
                suggestions =
                    querySuggestions
                        .slice(0, querySuggestions.length - 1)
                        .map(linkFunction)
                        .join(generalDelimeter) +
                    lastDelimeter +
                    linkFunction(querySuggestions[querySuggestions.length - 1]);
            }

            const prompt = promptString.replace('${suggestions}', suggestions);

            return new HawkSearch.handlebars.SafeString(prompt);
        });
    }

    protected override renderContent(): boolean {
        return !!this.data && !!this.data.display && !!this.data.querySuggestions?.length;
    }

    protected override getContentModel(): QuerySuggestionsComponentModel {
        return {
            querySuggestions: this.data!.querySuggestions ?? []
        };
    }

    protected bindChildElements(): void {
        this.rootElement.querySelectorAll('[hawksearch-query]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLElement;
                const query = element.getAttribute('hawksearch-query');

                if (query) {
                    searchService.query(query);
                }
            });
        });
    }
}
